var ShopAuth = {};
ShopAuth.init = function () {

  ShopAuth.loginForm = document.forms.loginForm;
  ShopAuth.regForm = document.forms.regForm;


  $(".login_modal_open").click(function (evt) {
    evt.preventDefault();
    $('#login_modal').popup('show');
  });

  $(ShopAuth.loginForm).find('.btn-submit').click(function () {

    var login = {
      username: ShopAuth.loginForm.elements.username.value,
      password: ShopAuth.loginForm.elements.password.value,
      remember: ShopAuth.loginForm.elements.remember.checked
    };
    if (ShopAuth.loginForm.elements.returnTo && ShopAuth.loginForm.elements.returnTo.value) {
      login.returnTo = ShopAuth.loginForm.elements.returnTo.value;
    }
    $(ShopAuth.loginForm).find('.form-error').hide();
    $('.btn-submit').attr("disabled");
    jQuery.ajax({
      url: "/login",
      method: "post",
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(login),
    }).then(function (resp) {
      if (resp.redirect) {
        window.location.pathname = resp.redirect;
        return;
      }
      $('.btn-submit').removeAttr("disabled");
      window.location.reload();
    }, function (resp) {
      $('.btn-submit').removeAttr("disabled");
      if (arguments[0].status === 401) {
        $(ShopAuth.loginForm).find('.form-error').show();
      }
    })
  });

  $(ShopAuth.regForm).find('.btn-submit').click(function () {
    $(ShopAuth.regForm).find('.form-error').hide();
    var register = {
      email: ShopAuth.regForm.elements.email.value,
      password: ShopAuth.regForm.elements.password.value,
      repassword: ShopAuth.regForm.elements.repassword.value,
      acceptance: ShopAuth.regForm.elements.acceptance.checked,
      remember: ShopAuth.regForm.elements.remember.checked
    };
    $('.btn-submit').attr("disabled");
    var reload = window.location.href.indexOf("/zamowienie") >= 0;
    jQuery.ajax({
      url: "/register",
      method: "post",
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(register),
    }).then(function (resp) {
      if (reload) {
        window.location.reload();
      } else {
        $('#login_modal').popup('hide');
        $('.btn-submit').removeAttr("disabled");
        $('#registerSuccess').popup({
          onclose: function () {
            window.location.reload();
          }
        }).popup('show');
      }
    }, function (resp) {
      $('.btn-submit').removeAttr("disabled");
      var errors = resp.responseJSON.errors;
      for (var name in errors) {
        $('.form-error.' + name + '-' + errors[name].kind).show();
      }
    })
  });
};

$(ShopAuth.init);
